import { render } from "./WheelInviteQuotaPanel.vue?vue&type=template&id=03200a8c&scoped=true"
import script from "./WheelInviteQuotaPanel.vue?vue&type=script&lang=js"
export * from "./WheelInviteQuotaPanel.vue?vue&type=script&lang=js"

import "./WheelInviteQuotaPanel.vue?vue&type=style&index=0&id=03200a8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03200a8c"]])

export default __exports__